module.exports = __webpack_public_path__ + "static/janitorial-9a3d9ed20c2a1a4668f76e2450d2a84f.png";